import { Check, File } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import warningIcon from '@/assets/invoices/warning.svg'

interface Props {
  open: boolean
  busy?: boolean
  onOpenChange: (open: boolean) => void
  onValidateAndSend: () => void
  onSendAsDraft: () => void
}

export function InvoiceSaveAndSendDialog({
  open,
  busy = false,
  onOpenChange,
  onValidateAndSend,
  onSendAsDraft,
}: Props) {
  const { t } = useTranslation('invoices')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className='max-w-[600px] gap-0 rounded-2xl border-border p-8 shadow-[0_8px_16px_-4px_rgba(38,45,66,0.1),0_1px_4px_-1px_rgba(38,45,66,0.05)] [&>button]:hidden'
        overlayClassName='bg-black/70 backdrop-blur-[2px]'
      >
        <div className='flex flex-col gap-6'>
          <div className='flex flex-col gap-3'>
            <div className='flex w-full items-center gap-4'>
              <span className='flex size-6 shrink-0 items-center justify-center'>
                <img
                  src={warningIcon}
                  alt=''
                  aria-hidden
                  className='h-[20.25px] w-[21.75px]'
                />
              </span>
              <DialogTitle className='font-heading text-base font-semibold leading-[1.2] tracking-normal text-[#171a20]'>
                {t('form.saveAndSendDialog.title')}
              </DialogTitle>
            </div>
            <div className='rounded-xl bg-[#fef3c7] p-3 font-sans text-sm font-normal leading-[1.4] text-[#171a20]'>
              {t('form.saveAndSendDialog.warningPrefix')}{' '}
              <span className='font-medium'>PRO FORMA</span>{' '}
              {t('form.saveAndSendDialog.warningSuffix')}
            </div>
          </div>

          <div className='flex flex-col gap-4'>
            <Button
              type='button'
              className='h-10 w-full gap-2 rounded-xl border border-[#ff5a1f] bg-[#ff5a1f] p-3 text-sm font-medium leading-none text-white hover:bg-[#e94f18]'
              disabled={busy}
              onClick={onValidateAndSend}
            >
              <Check className='size-4 text-[#fff1ea]' strokeWidth={2.4} />
              {t('form.saveAndSendDialog.validateAndSend')}
            </Button>
            <Button
              type='button'
              variant='outline'
              className='h-10 w-full gap-2 rounded-xl border-[#e7e9ef] bg-white p-3 text-sm font-medium leading-none text-[#171a20]'
              disabled={busy}
              onClick={onSendAsDraft}
            >
              <File className='size-4 text-[#272c36]' strokeWidth={2.4} />
              {t('form.saveAndSendDialog.sendAsProForma')}
            </Button>
            <Button
              type='button'
              variant='outline'
              className='h-[38px] w-full rounded-xl border-[#e7e9ef] bg-white p-3 text-sm font-medium leading-none text-[#171a20]'
              disabled={busy}
              onClick={() => onOpenChange(false)}
            >
              {t('form.saveAndSendDialog.cancel')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
